// removed by extract-text-webpack-plugin
module.exports = {"fade":"SnnTmDC","fade__entered":"dDRZo3X","fade__entering":"_3Sf7HnX","fade__exited":"_2DGNX8Z","fade__exiting":"_3IzcYIk"};


//////////////////
// WEBPACK FOOTER
// ./template/components/CountrySelector/Fade.css
// module id = ./template/components/CountrySelector/Fade.css
// module chunks = client.sitechrome